import React from 'react';

import { Address } from '../../components';
import { AddressForm } from '../../forms';
import { Button, Card, Icon } from '../../components/ui';

export function DeliveryAddress({ address, onEdit, onSubmit, onCancel, mode = 'edit', readOnly }) {
  const cancelButton = <Button variant="secondary" onClick={onCancel}>Cancel</Button>

  return (
    <section id="delivery" className="checkout__section">
      <p className="checkout__hint">We aim to deliver the products within 5 working days in Europe and 10-14 days worldwide. You will receive a tracking link once the order is dispatched.</p>

      {mode === 'edit' &&
        <AddressForm
          showName
          showPhone
          address={address}
          submitAction={onSubmit}
          secondButton={cancelButton}
          submitLabel="Continue"
        />
      }

      {mode === 'display' && (
        <>
          <Card>
            <Address address={address} />
          </Card>

          {!readOnly && (
            <div className="checkout__actions">
              <Button
                variant="secondary"
                onClick={onEdit}
                leadingIcon={<Icon name="MapPin" size="sm" />}
              >
                Change Delivery Address
              </Button>
            </div>
          )}
        </>
      )}
    </section>
  );
}
